import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full md:w-1/2 flex flex-col h-auto pb-4 md:pb-0 md:h-full" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "h-10 w-10 bg-zewotherm-lightgrey rounded-r-lg flex items-center justify-center" }

import { 
  IonImg, 
  IonIcon, 
} from '@ionic/vue';
import ActiveFilterChipLayout from './ActiveFilterChipLayout.vue';
import { useCompany } from '@/store/company';
import { closeCircle } from 'ionicons/icons';
import { ref, watch } from 'vue'
import FilterList from './FilterList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchArea',
  props: {
    modalOpen: { type: Boolean }
  },
  emits: ["searchProject", "setModalOpen", "searchValue"],
  setup(__props: any, { emit }: { emit: ({
  (event: "searchProject", value: boolean): Promise<void>,
  (event: "setModalOpen", value: boolean): void,
  (event: "searchValue", value: string): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modalOpen: boolean
}

const companyStore = useCompany()
const searchValue = ref("")





watch(() => searchValue.value, (newValue) => {
  emit("searchValue", newValue)
})

function searchProject(showLoading: boolean) {
  emit("searchProject", showLoading)
}

function setModalOpen(modalOpen: boolean) {
  emit("setModalOpen", modalOpen)
}

return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_label, { class: "w-full text-center text-2xl pb-4 md:block hidden" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(ActiveFilterChipLayout, { class: "pb-4" }),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (searchProject(true)), ["enter"])),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
        enterkeyhint: "search",
        class: "h-10 w-0 flex-grow bg-zewotherm-lightgrey text-zewotherm-darkGrey placeholder-zewotherm-grey font-bold rounded-l-lg p-2 pr-0 outline-none",
        placeholder: "Projekt"
      }, null, 544), [
        [_vModelText, searchValue.value]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_unref(IonIcon), {
          icon: _unref(closeCircle),
          onClick: _cache[2] || (_cache[2] = ($event: any) => {searchValue.value = ''; searchProject(true)}),
          class: "w-6 h-6 cursor-pointer"
        }, null, 8, ["icon"]), [
          [_vShow, searchValue.value.length > 0]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (setModalOpen(true))),
        style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
        class: "w-10 h-10 md:hidden rounded-lg cursor-pointer flex justify-center ml-3 items-center active:scale-90 duration-200"
      }, [
        _createVNode(_unref(IonImg), {
          src: "./assets/icon/filter.png",
          class: "w-3 h-3 invert"
        })
      ], 4)
    ]),
    (!props.modalOpen)
      ? (_openBlock(), _createBlock(FilterList, {
          key: 0,
          "list-class": "h-0 flex-grow w-full overflow-y-auto mt-2 hidden md:block",
          onFilterChanged: _cache[4] || (_cache[4] = ($event: any) => (searchProject(true)))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})